import createInterceptor from './Interceptor';

const baseURL = import.meta.env.VITE_DASHBOARD_MGR_URL;

const axiosInstance = createInterceptor({
  baseURL,
});

export default axiosInstance;
